var exports = {
  "zr": "x1cb7f6e3--c57e9e--root",
  "Om": "x1cb7f6e3--c57e9e--dot",
  "Pl": "x1cb7f6e3--c57e9e--dot-active",
};

module.exports = exports;
